export default "__VITE_ASSET__CFufVGg1__"